import React, { useEffect, useRef, useState } from 'react';
import { Button, Card, Result, Spin } from 'antd';
import { useHistory, useParams } from 'react-router';
import SITELINKS from 'constants/sitelinks';
import { JourneyKind, JourneyState } from 'interfaces/journey';
import { fetchJourney, useCreateJourney } from 'services/journeys';
import {
  forgetLastDraft,
  highlightMenuItem,
  lastDraft,
  rememberLastDraft,
} from './lastDraft';

const KINDS: Record<string, JourneyKind> = {
  shipments: 'shipments',
  collections: 'collections',
};

const NewJourney = () => {
  const history = useHistory();
  const { kind: rawKind } = useParams<{ kind: string }>();
  const kind = KINDS[rawKind];
  const { mutateAsync: createJourney } = useCreateJourney();
  const [failed, setFailed] = useState<string | null>(null);
  const started = useRef<JourneyKind | null>(null);

  const open = async () => {
    setFailed(null);
    try {
      const previous = lastDraft(kind);
      if (previous) {
        const journey = await fetchJourney(previous).catch(() => undefined);
        if (journey?.state === JourneyState.Draft) {
          highlightMenuItem('journeysPrep');
          history.replace(`${SITELINKS.journey}/${previous}`);
          return;
        }
        forgetLastDraft(kind);
      }
      const response = await createJourney(kind);
      if (!response?.journeyId) throw new Error('No se pudo crear la ruta');
      rememberLastDraft(kind, response.journeyId);
      highlightMenuItem('journeysPrep');
      history.replace(`${SITELINKS.journey}/${response.journeyId}`);
    } catch (error) {
      setFailed((error as Error)?.message ?? 'No se pudo crear la ruta');
    }
  };

  useEffect(() => {
    if (!kind || started.current === kind) return;
    started.current = kind;
    open();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [kind]);

  if (!kind) {
    return (
      <Result
        status="404"
        title="Ese tipo de ruta no existe"
        extra={
          <Button onClick={() => history.push(SITELINKS.journeysPrep)}>
            Ir a rutas en preparación
          </Button>
        }
      />
    );
  }

  if (failed) {
    return (
      <Result
        status="error"
        title="No se pudo crear la ruta"
        subTitle={failed}
        extra={[
          <Button key="retry" type="primary" onClick={open}>
            Reintentar
          </Button>,
          <Button
            key="list"
            onClick={() => history.push(SITELINKS.journeysPrep)}
          >
            Ir a rutas en preparación
          </Button>,
        ]}
      />
    );
  }

  return (
    <Card>
      <div style={{ textAlign: 'center', padding: 80 }}>
        <Spin tip="Abriendo la ruta…" size="large">
          <div style={{ height: 40 }} />
        </Spin>
      </div>
    </Card>
  );
};

export default NewJourney;
